import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { useState } from "react";
import AddHoliday from "../modals/AddHoliday";
import Button from "../reusable_components/Button";
import { title,btnOneNoWidth } from "../utils/style";



function Holidays() {
    const [ showForm, setShowForm ] = useState(false)
    const [ reloadTable, setReloadTable ] = useState(false)
    
    const options = [
        {
            header: 'Id',
            key: 'id',
            width: "30%"
        },
        {
            header: 'Date',
            key: 'date',
            placeHolder: 'mm-dd-yyyy',
            width: "30%"
        },
        {
            header: 'Occassion',
            key: 'occassion',
            width: "25%"
        }
    ]

    return(
        <div>            
            {
                showForm && <AddHoliday setShowForm={setShowForm} reload={setReloadTable}/>
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Holidays</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Holiday`} clickHandler={() => setShowForm(!showForm)} />
                )}
            </div>
            
            <Table 
                options={ options } 
                url={url + '/holidays'} 
                pagination 
                clickHandler={() => setShowForm(!showForm)}
                btnTitle={'Holiday'}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default Holidays;